import './scss/index.scss';

import '../../../shared/data';

import {Search} from "../../../shared/js/Search";
import {StatsTable} from "../../../shared/js/StatsTable";
import {Listings} from "../../../shared/js/Listings";
import {TradesCountBox_v2} from "../../../shared/js/TradesCountBox_v2";

$(document).ready(() => {

    let pgContainers = {
        parts: $('#trades_box_container'),
    };
    
    let useFacetOnTradesCountBox = true;


    if($('#catalog_product').length > 0) {
        useFacetOnTradesCountBox = false;
    }


    let tradesCountBoxOptions = {
        allowHiding: false,
        allowUpgradeMessages: true,
        container: pgContainers.parts,
        filters: $.extend({}, window.init_filters),
        removeTemplateMargin: true,
        tableTitle: 'In Stock Inventory',
        theme: 'white',
        useFaceting: useFacetOnTradesCountBox,
        showLoading: true,
    };
    if ($('#cat1').length > 0 || $('#cat2').length > 0 || $('#cat3').length > 0) {
        tradesCountBoxOptions['showManuBoxes'] = true;
        tradesCountBoxOptions['showBackToManusLink'] = true;
    }
    TradesCountBox_v2.set(tradesCountBoxOptions).init();


    _data.refresh(false, false);

    // TODO: refactor
    let statsTableOptions = '';
    if ($('#cat1').length > 0) {
        statsTableOptions = {
            groupByTitle: 'Sub-Categories',
            group_by: 'cat2',
            exclude_from_filter: ['type'],
            filters: $.extend(true, {}, window.init_filters),
            url_key: 'cat2id',
            solr_field: 'cat2id',
            url_endpoint: 'category_2',
            parent_keys: [
                {
                    url: 'cat1id',
                    solr: 'cat1id'
                }
            ],
            parent_endpoint: 'category_1'
        };
    } else if ($('#cat2').length > 0) {
        statsTableOptions = {
            groupByTitle: 'Sub-Categories',
            group_by: 'cat3',
            exclude_from_filter: ['type'],
            filters: $.extend(true, {}, window.init_filters),
            url_key: 'cat3id',
            solr_field: 'cat3id',
            url_endpoint: 'category',
            parent_keys: [
                {
                    url: 'cat2id',
                    solr: 'cat2id'
                }
            ],
            parent_endpoint: 'category_2'
        };
    } else if ($('#cat3').length > 0) {
        statsTableOptions = {
            groupByTitle: 'Manufacturers',
            group_by: 'manufacturer_name',
            exclude_from_filter: ['type', 'manufacturer_ids'],
            filters: $.extend(true, {
                is_major: true
            }, window.init_filters),
            url_key: 'm',
            solr_field: 'manu_id',
            url_endpoint: 'manufacturer',
            subGroups: [
                {
                    filter: {is_major: true},
                    title: 'Other Manufacturers'
                }
            ],
            parent_keys: [
                {
                    url: 'cat3id',
                    solr: 'cat3id'
                }
            ],
            parent_endpoint: 'category',
            additional_url_params: window.additionalURLParams
        };
    } else if ($('#catalog_brand').length > 0) {
        statsTableOptions = {
            groupByTitle: 'Series',
            group_by: 'model_name',
            exclude_from_filter: ['type','model_ids'],
            filters: $.extend(true, {}, window.init_filters),
            url_key: 'md',
            solr_field: 'model_id',
            url_endpoint: 'series',
            parent_keys:[
                {
                    url: 'b',
                    solr: 'brand_id'
                }
            ],
            parent_endpoint: 'brand'
        };
    } else if ($('#catalog_manufacturer').length > 0) {
        statsTableOptions = {
            groupByTitle: 'Brand',
            group_by: 'brand_name',
            exclude_from_filter: ['type', 'brand_ids'],
            filters: $.extend(true, {}, window.init_filters),
            url_key: 'b',
            solr_field: 'brand_id',
            url_endpoint: 'brand',
            parent_keys: [
                {
                    url: 'm',
                    solr: 'manu_id'
                },
                {
                    url: 'cat3id',
                    solr: 'cat3id'
                }
            ],
            parent_endpoint: 'manufacturer'
        };
    } else if ($('#catalog_series').length > 0) {
        statsTableOptions = {
            groupByTitle: 'Models',
            group_by: 'type_number',
            exclude_from_filter: ['type', 'type_ids'],
            filters: $.extend(true, {}, window.init_filters),
            url_key: 't',
            solr_field: 'catalog_model_types_id',
            url_endpoint: 'model',
            parent_keys: [
                {
                    url: 'md',
                    solr: 'model_id'
                }
            ],
            parent_endpoint: 'series'
        };
    } else if ($('#catalog_model').length > 0) {
        statsTableOptions = {
            groupByTitle: 'Part Numbers',
            group_by: 'part_number',
            exclude_from_filter: ['type'],
            filters: $.extend(true, {}, window.init_filters),
            url_key: 'k|catalogid',
            solr_field: 'part_number|item_id',
            url_endpoint: 'part',
            parent_keys: [
                {
                    url: 't',
                    solr: 'catalog_model_types_id'
                }
            ],
            parent_endpoint: 'model',
            additional_url_params: window.additionalURLParams
        };
    }

    Search.init({
        autocomplete: true,
        category_selector: true,
        filter_label: 'Search ' + (window.pageName ? window.pageName : 'this page'),
        container: $('#new_search_module')
    }, function() {
        $('.header-search').show();
    });

    if ($('#catalog_product').length === 0) {
        let solr_field_parts = statsTableOptions.solr_field.split('|');
        StatsTable.populate($.extend(true, statsTableOptions, {
            filters: $.extend(true, {}, window.init_filters),
            group_by: solr_field_parts[0],
            group_title: statsTableOptions.group_by,
            container: $('#stats-table')
        }));

        Listings.init();
        Listings.getListings();
    }

    $('.btn-contact-member').click(function() {
        if (!is_logged_in) {
            tradeloop.modal('register', null, {type: 'reply'}, 'products-single/trades-box/part-link-left/');
            return false;
        }
    });
});
